import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import { GRID_STRING_COL_DEF } from "./gridStringColDef.es.js";
import { renderActionsCell } from "../components/cell/GridActionsCell.es.js";
const GRID_ACTIONS_COLUMN_TYPE = "actions";
const GRID_ACTIONS_COL_DEF = _extends({}, GRID_STRING_COL_DEF, {
  sortable: false,
  filterable: false,
  // @ts-ignore
  aggregable: false,
  width: 100,
  align: "center",
  headerAlign: "center",
  headerName: "",
  disableColumnMenu: true,
  disableExport: true,
  renderCell: renderActionsCell,
  getApplyQuickFilterFn: void 0,
  getApplyQuickFilterFnV7: void 0
});
export {
  GRID_ACTIONS_COLUMN_TYPE,
  GRID_ACTIONS_COL_DEF
};
//# sourceMappingURL=gridActionsColDef.es.js.map
